export const NATIVE_APP_SCHEME = 'com.lender.adminpanel';

// Toggled on <html> while the native software keyboard is visible (see installKeyboardVisibilityClass).
// Lets layout react to the keyboard deterministically — and only on native, since the class is set
// exclusively by the Capacitor Keyboard plugin's events.
export const KEYBOARD_OPEN_CLASS = 'skynet-keyboard-open';

// Set on <html> for the lifetime of the native shell (see applyNativePlatformClass). Scopes the
// native-only document rules — text selection, long-press callout — so the web build is untouched.
export const NATIVE_PLATFORM_CLASS = 'skynet-native';

export const NATIVE_SSO_CALLBACK_HOST = 'sso';

export const NATIVE_SSO_TOKEN_KEY_PARAM = 'ssoTokenKey';

export const PATH_SSO_LOGIN_RELATIVE = '/login/sso';
